__webpack_require__.p = "/assets/components/headerfooter/us/npr/build/";